/**
 * @name banner hero banner slider
 * @function handle slider banner
 */


$(function() {
  const $carousel = $('#banner-slider');
  const $carouselNav = $('#banner_nav a');
  if (!$carousel.length || $carousel.children().length < 2) return;

  $carousel.slick({
    dots: false,
    arrows: false,
    speed: 800,
    slidesToShow: 1,
    infinite: true,
    autoplay: false,
    cssEase: 'ease-out',
    accessibility: false,
    responsive: [{
      breakpoint: 960,
      settings: { dots: true, fade: true }
    }]
  });

  $carouselNav.on('click', function(e) {
    e.preventDefault();
    if (!$carousel.hasClass('slick-initialized')) return;
    const index = $(this).data('slide');
    if (index == null) return;
    $carousel.slick('slickGoTo', index);
    $carouselNav.removeClass('active');
    $(this).addClass('active');
  });

  $carousel.on('afterChange', function(_, __, currentSlide) {
    $carouselNav.removeClass('active');
    $carouselNav.filter('[data-slide='+currentSlide+']').addClass('active');
  });
});
